'use client';

import React from 'react';
import Link from 'next/link';
import { Home, Search, ArrowLeft } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="flex justify-center mb-10">
          <Link href="/welcome" className="flex items-center gap-2">
            <AppLogo size={32} />
            <span className="text-lg font-bold text-foreground">Wealth<span className="text-primary">OS</span></span>
          </Link>
        </div>

        {/* 404 Visual */}
        <div className="relative mb-8">
          <h1 className="text-[120px] sm:text-[160px] font-black text-primary/8 leading-none select-none">404</h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-3xl bg-primary/10 border border-primary/20 flex items-center justify-center">
              <Search size={36} className="text-primary" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-foreground mb-3">Page Not Found</h2>
        <p className="text-sm text-muted-foreground leading-relaxed mb-8 max-w-sm mx-auto">
          The page you&apos;re looking for doesn&apos;t exist or has been moved. Let&apos;s get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
          <Link
            href="/welcome"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-semibold text-sm hover:bg-primary/90 transition-all hover:-translate-y-0.5"
          >
            <Home size={16} />
            Back to Home
          </Link>
          <button
            onClick={() => window.history?.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-border bg-muted/50 text-foreground font-semibold text-sm hover:bg-muted/80 transition-colors"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>

        {/* Quick links */}
        <div className="border-t border-border/50 pt-6">
          <p className="text-xs text-muted-foreground mb-3">Quick links</p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs">
            <Link href="/login" className="text-muted-foreground hover:text-primary transition-colors">Sign In</Link>
            <Link href="/register" className="text-muted-foreground hover:text-primary transition-colors">Get Started</Link>
            <Link href="/support" className="text-muted-foreground hover:text-primary transition-colors">Support</Link>
            <Link href="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}